// This file is generated by pnpm icons:generate. Do not edit.

import {Bubbles_Stroke2_Corner2_Rounded as CanonicalBubbles_Stroke2_Corner2_Rounded} from './Bubbles'
import {createSinglePathSVG} from './TEMPLATE'

export const Bubble_Filled_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M21.75 12a9.75 9.75 0 0 1-14.332 8.608l-3.193 1.064a1.5 1.5 0 0 1-1.897-1.897l1.064-3.192A9.75 9.75 0 1 1 21.75 12Z',
  viewBox: '0 0 24 24',
  glyph: 'Bubble_Filled_Stroke2_Corner2_Rounded',
})

export const Bubble_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M12 2.25a9.75 9.75 0 0 0-8.608 14.333l-1.064 3.192a1.5 1.5 0 0 0 1.897 1.897l3.192-1.064A9.75 9.75 0 1 0 12 2.25Zm0 18a8.24 8.24 0 0 1-4.13-1.107.75.75 0 0 0-.614-.063L3.75 20.25l1.17-3.506a.75.75 0 0 0-.063-.613A8.25 8.25 0 1 1 12 20.25Z',
  viewBox: '0 0 24 24',
  glyph: 'Bubble_Stroke2_Corner2_Rounded',
})

export const Bubble_Stroke2_Corner3_Rounded = createSinglePathSVG({
  path: 'M12 2.25a9.75 9.75 0 0 0-8.608 14.333l-1.064 3.192a1.5 1.5 0 0 0 1.897 1.897l3.192-1.064A9.75 9.75 0 1 0 12 2.25Zm0 18a8.24 8.24 0 0 1-4.13-1.107.75.75 0 0 0-.614-.063L3.75 20.25l1.17-3.506a.75.75 0 0 0-.063-.613A8.25 8.25 0 1 1 12 20.25Z',
  viewBox: '0 0 24 24',
  glyph: 'Bubble_Stroke2_Corner3_Rounded',
})

export const BubbleInfo_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M15.75 10.5a.75.75 0 0 1-.75.75H9a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75ZM15 12.75H9a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5Zm6.75-.75a9.75 9.75 0 0 1-14.332 8.608l-3.193 1.064a1.5 1.5 0 0 1-1.897-1.897l1.064-3.192A9.75 9.75 0 1 1 21.75 12Zm-1.5 0a8.25 8.25 0 1 0-15.393 4.13.75.75 0 0 1 .062.614L3.75 20.25l3.506-1.17a.7.7 0 0 1 .237-.038.75.75 0 0 1 .375.1A8.25 8.25 0 0 0 20.25 12Z',
  viewBox: '0 0 24 24',
  glyph: 'BubbleInfo_Stroke2_Corner2_Rounded',
})

export const BubbleQuestion_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M13.125 16.875A1.125 1.125 0 1 1 12 15.75a1.125 1.125 0 0 1 1.125 1.125ZM12 6.75c-2.068 0-3.75 1.514-3.75 3.375v.375a.75.75 0 0 0 1.5 0v-.375c0-1.031 1.01-1.875 2.25-1.875s2.25.844 2.25 1.875S13.24 12 12 12a.75.75 0 0 0-.75.75v.75a.75.75 0 0 0 1.5 0v-.067c1.71-.315 3-1.679 3-3.308 0-1.86-1.682-3.375-3.75-3.375ZM21.75 12A9.75 9.75 0 1 1 12 2.25 9.76 9.76 0 0 1 21.75 12Zm-1.5 0A8.25 8.25 0 1 0 12 20.25 8.26 8.26 0 0 0 20.25 12Z',
  viewBox: '0 0 24 24',
  glyph: 'BubbleQuestion_Stroke2_Corner0_Rounded',
})

export const BubbleSmile_Stroke2_Corner2_Rounded_Large = createSinglePathSVG({
  path: 'M35 32a3 3 0 1 1-3-3 3 3 0 0 1 3 3Zm-14-3a3 3 0 1 0 3 3 3 3 0 0 0-3-3Zm22 0a3 3 0 1 0 3 3 3 3 0 0 0-3-3Zm15 3a26 26 0 0 1-38.22 22.955l-8.513 2.837a4 4 0 0 1-5.06-5.06l2.838-8.512A26 26 0 1 1 58 32Zm-4 0a22 22 0 1 0-41.047 11.015 2 2 0 0 1 .165 1.635L10 54l9.35-3.117a2 2 0 0 1 .633-.106 2 2 0 0 1 1 .27A22 22 0 0 0 54 32Z',
  viewBox: '0 0 64 64',
  glyph: 'BubbleSmile_Stroke2_Corner2_Rounded_Large',
})

/** @deprecated Import Bubbles_Stroke2_Corner2_Rounded from `#/components/icons/Bubbles` instead. */
export const Bubbles_Stroke2_Corner2_Rounded =
  CanonicalBubbles_Stroke2_Corner2_Rounded
